class loadUSDitems {
    #itemFetchUrl = ""
    #rawData = ""
    #cartItems = "";
    #usdRateApi = "https://ustore.secureapps.center/api/get-usd-rate"
    apiRandKey = "";
  
    constructor() {
      const key = this.getCookie("apiRandKey");
      const urlParams = new URLSearchParams(window.location.search);
      const orderId = urlParams.get('rand');
      
      if(key) {
        this.apiRandKey =key;
      }

      if(!key && !orderId) {
        try {
          const notes = JSON.parse( JSON.parse(window.localStorage.getItem("fromUstore")).notes )
          let apiRandKey = "";
          notes.forEach(val=>{
              if(val.name == "apiRandKey") {
                  apiRandKey = (val.value)
              }
          })
          this.apiRandKey = apiRandKey;
          this.setCookie("apiRandKey", apiRandKey, 1);
        }catch(e) {
          this.apiRandKey = "RAND_";
          while (apiRandKey.length < 69 ) {
            const randNum = Math.round(Math.random() * (89 - 65 + 1)) + 65
            let letter = String.fromCharCode(randNum);
            if (randNum % 2 != 0 ) {
              letter = letter.toLowerCase();
            }
            apiRandKey += letter;
          }
          this.apiRandKey = apiRandKey;
          this.setCookie("apiRandKey", apiRandKey, 1);
        }
      }
      this.asyncConstructor()
    }

  async asyncConstructor () {
    //here needs to call item call url
    const urlParams = new URLSearchParams(window.location.search);
    const orderId = urlParams.get('rand');

    this.updateUSDValue()
    this.fetchOrderDetails();
    this.createListeners()
  }

  async updateUSDValue() {
      const _fetch = await fetch(this.#usdRateApi, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify( {
          "apiRandKey": this.apiRandKey
        } )
      });
      const result = await _fetch.json();

      window.localStorage.setItem("usdRate", result.rate);
      //this.usdValue = result.rate;
  }

  createListeners() {
    window.addEventListener("DOMContentLoaded", this.changeElems.bind(this), false);
  }

  changeElems() {
    const needToRemove = document.querySelectorAll(`.cartitems--list a[href*="/products/"]`);
    //console.log(needToRemove)
    const needToChange = document.querySelectorAll(`.ecom-nav-right a[href]:not(a[href="/cart"])`);
    //console.log(needToChange)

    for(let elem of needToRemove) {
      elem.removeAttribute("href")
    }

    for(let elem of needToChange) {
     // elem.href = "https://utest04.myshopify.com/" + elem.href;
      elem.href = "https://ustore.lk/" + elem.getAttribute("href");
    }
  }

    setCookie(name,value,days) {
      var expires = "";
      if (days) {
          var date = new Date();
          date.setTime(date.getTime() + (days*24*60*60*1000));
          expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "")  + expires + "; path=/";
  }
  
  getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for(var i=0;i < ca.length;i++) {
          var c = ca[i];
          while (c.charAt(0)==' ') c = c.substring(1,c.length);
          if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
      }
      return "";
  }

    async fetchOrderDetails() {
      const urlParams = new URLSearchParams(window.location.search);
      const orderId = urlParams.get('rand');

      if(orderId == "" || !orderId) {
        const template = document.getElementById("im-in").dataset.template;
        if(template != "cart" ) {
          console.log("please remove below comment after development");
         // window.location.href = "https://ustore.lk/";
          return
        }

        //cart loaded after product added to cart
        window.addEventListener("DOMContentLoaded", function(){
          document.body.hidden = false;
        }.bind(this), {once: true});
        return
      }
      
      console.log("here run fetch the items from whm");
      console.log(this.#rawData)
      //after fetch call to create create item data
      const _fetch = await fetch("https://ustore.secureapps.center/api/get-order-data/"+orderId, {
        method: "POST",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json"
        },
        body: JSON.stringify( { "apiRandKey": this.apiRandKey } )
      });

      // const _fetch = await fetch("https://ustore.secureapps.center/api/get-order-data/"+orderId, {
      //   method: "GET",
      //   headers: {
      //     Accept: "*/*"
      //   }
      // });
      const _json = await _fetch.json();
      this.#rawData = (_json);
      window.localStorage.setItem("fromUstore", JSON.stringify(_json));

      const notes = JSON.parse(_json.notes);
      let apiRandKey = "";
      notes.forEach(val=>{
          if(val.name == "apiRandKey") {
              apiRandKey = (val.value)
          }
      })
      
      //set apiRandKey cookie
      this.apiRandKey = apiRandKey;
      this.setCookie("apiRandKey", apiRandKey, 1);

      //set customer mobile
      const cartNotes = JSON.parse(this.#rawData.notes);
      if(cartNotes[4].value != null) {
        this.setCookie("Cus_mobile",cartNotes[4].value, 7)
      }
      this.addItemToCart()
    }

    addItemToCart() {
      this.#cartItems = []
        console.log(this.#rawData)
      for(let item of this.#rawData.items) {
        //this.#cartItemsLink += item.variant_id +":"+ item.itemCount+",";
          const obj = {};
          obj['id'] = item.variant_id;
          obj['quantity'] = item.request_qty;
          this.#cartItems.push(obj);
      }
      this.sendFetch()
    }

    async sendFetch() {
      console.log("sendFetch")
        const _clearFetch = await fetch ("/"+ "cart/clear.js")
      const _fetch = await fetch("/" + "cart/add.js", {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({items: this.#cartItems})
      });

        //removed this because alredy in the cart
      window.location.href = "/cart"
    } 
  }

window.loadUSD = new loadUSDitems();

//run in cart page to change item quty
class changeItemCount {
  
  constructor() {
    this.createListeners();
  }

  createListeners() {
    window.addEventListener("DOMContentLoaded", this.changeItemCount.bind(this), false);
  }

  changeItemCount () {
    let fromUstoreItems = window.localStorage.getItem("fromUstore");
    if (!fromUstoreItems || fromUstoreItems =="") {
      return;
    }

    fromUstoreItems = JSON.parse(fromUstoreItems);
    for(let item of fromUstoreItems.items) {
      const variantId = item.variant_id;

      const allElemntsOfVariant = document.querySelectorAll(`.pluse_btn[data-variant="${variantId}"], .minus_btn[data-variant="${variantId}"]`);
      for(let elem of allElemntsOfVariant) {
        elem.dataset.qty = item.available_qty;
      }
    }
  }
}

window.cartChangeItemCount = new changeItemCount();